import React from 'react'
import Layout from '../utils/layout'
import Seo from '../utils/seo'
import { sortComponents, hideComponents } from '../utils/helpers'
import Header from '../components/TestosteroneLinePage/Header'
import Stats from '../components/TestosteroneLinePage/Stats'
import Warranty from '../components/Shared/Warranty'
import Protocols from '../components/TestosteroneLinePage/Protocols'
import Articles from '../components/TestosteroneLinePage/Articles'
import Doctors from '../components/TestosteroneLinePage/Doctors'
import Levels from '../components/TestosteroneLinePage/Levels'
import Blocks from '../components/TestosteroneLinePage/Blocks'
import OtherProtocols from '../components/TestosteroneLinePage/OtherProtocols'
import Benefits from '../components/TestosteroneLinePage/Benefits'
import Faq from '../components/TestosteroneLinePage/Faq'
import FoodDrug from '../components/TestosteroneLinePage/FoodDrug'

export const Head = ({ location, pageContext }) => (
  <Seo location={location} pageContext={pageContext} />
)

const TestosteroneLineMultiple = ({ pageContext: { data } }) => {
  const components = [
    {
      render: i => <Stats stats={data.stats} key={i} />,
      priority: data.stats?.priority || 99,
      hidden: !data.stats || data.stats.isHide
    },
    {
      render: i => <Warranty warranty={data.warranty} key={i} />,
      priority: data.warranty?.priority || 99,
      hidden: !data.warranty || data.warranty.isHide
    },
    {
      render: i => <Doctors doctors={data.doctors} key={i} />,
      priority: data.doctors?.priority || 99,
      hidden: !data.doctors || data.doctors.isHide
    },
    {
      render: i => <Protocols protocols={data.protocols} key={i} />,
      priority: data.protocols?.priority || 99,
      hidden: !data.protocols || data.protocols.isHide
    },
    {
      render: i => <Articles articles={data.articles} key={i} />,
      priority: data.articles?.priority || 99,
      hidden: !data.articles || data.articles.isHide
    },
    {
      render: i => <OtherProtocols otherProtocols={data.otherProtocols} key={i} />,
      priority: data.otherProtocols?.priority || 99,
      hidden: !data.otherProtocols || data.otherProtocols.isHide
    },
    {
      render: i => <Blocks blocks={data.blocks} key={i} />,
      priority: data.blocks?.priority || 99,
      hidden: !data.blocks || data.blocks.isHide
    },
    {
      render: i => <Levels levels={data.levels} key={i} />,
      priority: data.levels?.priority || 99,
      hidden: !data.levels || data.levels.isHide
    },
    {
      render: i => <Benefits benefits={data.benefits} key={i} />,
      priority: data.benefits?.priority || 99,
      hidden: !data.benefits || data.benefits.isHide
    },
    {
      render: i => <Faq faq={data.faq} key={i} />,
      priority: data.faq?.priority || 99,
      hidden: !data.faq || data.faq.isHide
    },
    {
      render: i => <FoodDrug foodDrug={data.foodDrug} key={i} />,
      priority: data.foodDrug?.priority || 99,
      hidden: !data.foodDrug || data.foodDrug.isHide
    },
  ].filter(hideComponents).sort(sortComponents)

  return (
    <Layout data={data} signUpUrl={data.header?.buttonUrl} signUpText={data.header?.buttonText}>
      {data.header && <Header header={data.header} />}
      {components.map((component, i) => component.render(i))}
    </Layout>
  )
}

export default TestosteroneLineMultiple